import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function apontamentoReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        // const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);
        const hP = new TableReportHelper(apontamento);
        content.push([
            await apontamentoHeaderLocalizacaoReport(visita, indicador, apontamento, params),
            hP.panel(
                [
                    hP.row(
                        hP.title("Tipo Indicador"),
                        hP.title("Turno"),
                    ),

                    hP.row(
                        hP.textField("tipoIndicador"),
                        hP.textField("turno"),

                    ),
                ],
                { widths: ["*", "*"] }
            ),
            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Profundidade (cm)", "Conforme"],
                // prettier-ignore
                (h) => [
                    h.numberField("profundidadeColeta"),
                    h.textField("conforme"),
                ],
                [80, 60]
            ),

            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "cm", indicador.type),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
